import { render, staticRenderFns } from "./ReserveFundPage.vue?vue&type=template&id=6b9c47f6&"
import script from "./ReserveFundPage.vue?vue&type=script&lang=ts&"
export * from "./ReserveFundPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports